import { Modal } from 'antd';
import styled from 'styled-components/macro';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 32px;
  }
`;
